import WarningAmber from "@mui/icons-material/WarningAmber";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import Stack from "@mui/material/Stack/Stack";
import Typography from "@mui/material/Typography/Typography";
import { NumericFormat } from "react-number-format";
import { useSelector } from "react-redux";

import { RootState } from "../../../store/store";
import { FeeType, IBookingInfo3 } from "../../../types/types";

interface IProps {
  chargedCancelledByFee: {
    [key: string]: IBookingInfo3[];
  };
}
export default function CancellableChargedBookings(props: IProps) {
  const serviceRolls = useSelector((state: RootState) => state.session.rolls);
  const { chargedCancelledByFee } = props;
  return serviceRolls !== null ? (
    <List disablePadding={true} sx={{ p: 1, pb: 0 }}>
      {Object.keys(chargedCancelledByFee).map((feeType, index) => {
        const allAvBookings = chargedCancelledByFee[feeType];
        return (
          <ListItem
            disableGutters
            alignItems="center"
            key={index}
            secondaryAction={
              <span className="small">
                <NumericFormat
                  displayType="text"
                  prefix="$"
                  value={allAvBookings.reduce((acc, curr) => acc + curr.fee, 0)}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  suffix="*"
                />
              </span>
            }
          >
            <ListItemAvatar sx={{ minWidth: "35px" }}>
              <WarningAmber fontSize="small" htmlColor="var(--custom-color-error)" />
            </ListItemAvatar>
            <ListItemText
              disableTypography={true}
              primary={
                <Typography variant="subtitle2" fontWeight="bold" color={"var(--custom-color-error)"}>
                  {`${serviceRolls?.find((r) => r.rollId === allAvBookings[0].rollId)?.rollName} - Late Cancellation`}
                  {(feeType as FeeType) === FeeType.Casual ? " (Casual)" : ""}
                </Typography>
              }
              secondary={
                <Stack direction="column">
                  {feeType !== FeeType.Casual && (
                    <Typography
                      variant="subtitle2"
                      sx={{
                        wordBreak: "break-word",
                        fontSize: {
                          xl: "1rem",
                          lg: "0.9rem",
                          md: "0.9rem",
                          sm: "0.7rem",
                          xs: "0.7rem",
                        },
                      }}
                    >
                      {allAvBookings.length > 1 &&
                        `${allAvBookings[0].date.format("ddd DD MMM")} to ${allAvBookings[
                          allAvBookings.length - 1
                        ].date.format("ddd DD MMM")}`}
                      {allAvBookings.length === 1 && allAvBookings[0].date.format("ddd DD MMM")}
                    </Typography>
                  )}

                  <Typography variant="subtitle2">
                    <span className="small">
                      <NumericFormat
                        displayType="text"
                        prefix={`${allAvBookings.length} x $`}
                        value={allAvBookings[0].fee}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        suffix="*"
                      />
                    </span>
                  </Typography>
                </Stack>
              }
            />
          </ListItem>
        );
      })}
    </List>
  ) : null;
}
